import { AddressMultiSelect, ContractorMultiSelect } from "../../_components/Contractors/ContractorMultiSelect";
import { FormDomain } from "../../_components/Forms/FormDomain";
import { useFieldArray, useFormContext } from "react-hook-form";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { DomainButton } from "../../_components/Abstractions/DomainButton";
import { LoadingSpinner } from "../../_components/Abstractions/LoadingSpinner";
import { WasteFormType } from "../../domain/WasteFormType";
import { stringToDateForm, stringToDateView } from "../../domain/Configuration";
import { HorizontalView } from "../../_components/Abstractions/HorizontalView";
import { Card } from "react-bootstrap";
import { ReadonlyControl } from "../../_components/Forms/ReadonlyControl";
import { NumericControl } from "../../_components/Forms/NumericControl";
import { FormControl } from "../../_components/Forms/FormControl";
import { RadioButtonGroup } from "../../_components/Abstractions/RadioButtonGroup";
import { ratePlansActions } from "../../_store/ratePlan.slice";
import { WastesKindsMultiSelect } from "../contractors/Extensions/CreateContractor/WastesKindsMultiSelect";
import { Dropdown } from "../../_components/Abstractions/Dropdown";
import { RATE_PLAN_TYPE, RatePlanType } from "../../domain/RatePlanType";

export function UpdateRatePlansBatch() {
  const dispatch = useDispatch();
  const formControls = <div>
    <h1>Aktualizacja cenników</h1>
    <h5>1. Wybór kontrahentów / adresów</h5>
    <>Kontrahenci</>
    <ContractorMultiSelect name="contractorsIds" label="Kontrahenci"/>
    <>Adresy</>
    <AddressMultiSelect name="addressesIds" label="Adresy"/>
    <h5>2. Wybór towarów</h5>
    <WastesKindsMultiSelect
      name="wastesKinds"
      includeAllWasteKinds
      required={false}
      optionSave={(x) => ({ wasteId: x.wasteId, wasteKindId: x.wasteKindId })} />
    <h5>3. Dane cenników</h5>
    <LoadRatePlansForContractor/>
    <h5>4. Tryb zmiany stawek</h5>
    <RatePlansUpdateBatchMode/>
    <h5>5. Dostosuj stawki</h5>
    <PriceAdjustmentControls />
    <RatePlansUpdateBatchForm/>
  </div>

  const onSubmit = (data) => {
    if(data.ratePlans.length === 0) {
      return { error: { message: "Brak stawek do zaktualizowania." } }
    }

    const items = getRatePlanItems(data);

    const payload = {
      mode: data.updateMode,
      items: items
    };
    return dispatch(ratePlansActions.upsertRatePlansBatch({ payload }));
  }

  return <>
    <FormDomain
      formControls={formControls}
      defaultValues={{ ratePlanType: RATE_PLAN_TYPE.PURCHASE }}
      // validationSchema={validationSchema}
      onSubmit={onSubmit}
      successMessage="Zaktualizowano stawki cenników"
    />
  </>
}

const LoadRatePlansForContractor = () => {
  const dispatch = useDispatch();
  const { watch, setValue } = useFormContext();
  const contractorsIds = watch("contractorsIds");
  const addressesIds = watch("addressesIds");
  const wastesKinds = watch("wastesKinds") ?? [];
  const ratePlanDate = watch("ratePlanDate");
  const ratePlanType = watch("ratePlanType");
  const priceFrom = watch("priceFrom");
  const priceTo = watch("priceTo");
  const ratePlans = watch("ratePlans");
  const [isLoading, setIsLoading] = useState(false);

  const getRateTitle = (rate) => {
    return `${rate.waste.displayDescription} (${rate.wasteKind?.name ?? "-"})`;
  }

  const refreshRatePlans = async() => {
    setIsLoading(true);
    const { payload: items} =
      await dispatch(ratePlansActions.searchRatePlansForContractors({
        payload: {
          contractorsIds,
          addressesIds,
          ratePlanType: ratePlanType,
          ratePlanDate: ratePlanDate !== "" ? ratePlanDate : null,
          priceFrom: priceFrom !== "" ? parseFloat(priceFrom) : null,
          priceTo: priceTo !== "" ? parseFloat(priceTo) : null,
          wastesIds: Array.from(new Set(wastesKinds.filter(x => !x.wasteKindId)?.map(x => x.wasteId) ?? [])),
          wastesKindsIds: wastesKinds?.filter(x => !!x.wasteKindId).map(x => x.wasteKindId) ?? []
        }
      }))

    const getWasteFormType = (rate) => {
      if(!rate.isAdvancedPricing) {
        return "-";
      }

      return Object.keys(rate.wasteAdvancedPricing)?.[0];
    }

    const ratePlans = items?.map(x => {
      const dateToForOriginalRatePlan = x.dateTo ? new Date(x.dateTo) : new Date();
      const dateFromForNewRatePlan = new Date().setDate(dateToForOriginalRatePlan.getDate() + 1);

      // if (!x.dateTo) {
      //   dateToForOriginalRatePlan = new Date());
      // }
        // dateToForOriginalRatePlan?.setDate(new Date(x.dateTo).getDate() + 1);

      return ({
        ...x,
        ratePlanId: x.id,
        title: x.contractorName,
        subtitle: getRatePlanSubtitle(x),
        dateToForOriginalRatePlan: stringToDateForm(dateToForOriginalRatePlan),
        dateFromForNewRatePlan: stringToDateForm(dateFromForNewRatePlan),
        ratePlanDate: new Date(),
        wastes: x.wastes.map(rate => ({
          ...rate,
          title: getRateTitle(rate),
          wasteFormType: getWasteFormType(rate),
          originalPrice: rate.price
        }))
      });
    });

    setValue("ratePlans", ratePlans ?? []);
    setIsLoading(false);
  }

  return <div>
    {/*<div>Selected Contractors: {JSON.stringify(contractorsIds)}</div>*/}
    {/*<div>Selected Wastes: {JSON.stringify(wastesIds)}</div>*/}
    <div className="d-flex flex-column align-items-start mb-2">
      <HorizontalView>
        <Dropdown name="ratePlanType" label="Typ cennika" items={RatePlanType}/>
        <FormControl name="ratePlanDate" label="Cenniki na dzień" inputType="date"/>
        <FormControl inputType="number" name="priceFrom" label="Cena od"/>
        <FormControl inputType="number" name="priceTo" label="Cena do"/>
      </HorizontalView>
    <DomainButton onClick={refreshRatePlans}>Wczytaj cenniki</DomainButton> <LoadingSpinner as="div" isLoading={isLoading}/>
    </div>
    {/*<div>Loaded RatePlans: {JSON.stringify(ratePlansIds)}</div>*/}
    <h5>Znalezione cenniki: {ratePlans?.length ?? "-"}</h5>
    <ul className="upper">
      {ratePlans?.map((ratePlan, idx) => <li key={idx}><b>{ratePlan.contractorName}</b> - {getRatePlanSubtitle(ratePlan)} - liczba stawek: {ratePlan.wastes.length}</li>)}
    </ul>
    <hr/>
  </div>
}

const RatePlansUpdateBatchForm = () => {
  const { getValues, watch } = useFormContext();
  // const { fields: ratePlans } = useFieldArray({ name: "ratePlans" });
  const updateMode = watch("updateMode");
  const ratePlans = getValues("ratePlans");
  const getRateField = (ratePlanIdx, ratePlanField) => {
    return `ratePlans[${ratePlanIdx}].[${ratePlanField}]`;
  }

  const getRatePriceField = (ratePlanIdx, rateIdx) => {
    return `ratePlans[${ratePlanIdx}].wastes[${rateIdx}].price`;
  }
  return ratePlans?.map((ratePlan, ratePlanIdx) => <div key={ratePlan.id} className="upper">
    <Card>
      <Card.Body>
        <Card.Title>{ratePlan.contractorName}</Card.Title>
        <Card.Subtitle>{getRatePlanSubtitle(ratePlan)}</Card.Subtitle>
        {updateMode === "clone" && <div className="mt-2">
          <HorizontalView columnsSize={[2, 2, 2]}>
            <FormControl name={getRateField(ratePlanIdx, "dateToForOriginalRatePlan")} label="Data końcowa obecnego cennika" required={true} inputType="date"/>
            <FormControl name={getRateField(ratePlanIdx, "dateFromForNewRatePlan")} label="Data początkowa nowego cennika" required={true} inputType="date"/>
            <FormControl name={getRateField(ratePlanIdx, "dateToForNewRatePlan")} label="Data końcowa nowego cennika" required={true} inputType="date"/>
          </HorizontalView>
        </div>}
        <div className="my-2">{ratePlan.wastes.map((rate, rateIdx) =>
          <div key={rateIdx}>
            <HorizontalView columnsSize={[4,1, 1, 1]}>
            <ReadonlyControl label="Towar">{rate.title}</ReadonlyControl>
            <ReadonlyControl label="Forma">{WasteFormType[rate.wasteFormType] ?? "-"}</ReadonlyControl>
            <ReadonlyControl label="Obecna cena">{rate.originalPrice}</ReadonlyControl>
            <NumericControl label="Nowa cena" name={getRatePriceField(ratePlanIdx, rateIdx)} required={true}/>
            {/*<ReadonlyControl label="Zaawansowany cennik?">{rate.isAdvancedPricing}</ReadonlyControl>*/}
            </HorizontalView>
          </div>)}
        </div>
      </Card.Body>
    </Card>
    <hr/>
  </div>);
}

const RatePlansUpdateBatchMode = () => {
  const updateModes = [
    { name: "Kopiowanie", value: "clone" },
    { name: "Aktualizacja", value: "update" }
  ];

  return <div>
        <RadioButtonGroup label="Tryb zmiany" name="updateMode" items={updateModes} defaultChecked="clone"/>
    </div>
}

const getRatePlanSubtitle = (ratePlan) => {
  return `${ratePlan.description} ${stringToDateView(ratePlan.dateFrom)} - ${ratePlan.dateTo ? stringToDateView(ratePlan.dateTo) : "..."}`;
}

const PriceAdjustmentControls = () => {
  // const { watch, setValue } = useFormContext();
  const { replace, fields: ratePlans } = useFieldArray({ name: "ratePlans" });
  // const ratePlans = watch("ratePlans");
  const [adjustmentType, setAdjustmentType] = useState("percent");
  const [adjustmentValue, setAdjustmentValue] = useState(0);

  const applyAdjustment = () => {
    if (!ratePlans?.length) return;

    const updatedPlans = ratePlans.map((plan) => ({
      ...plan,
      wastes: plan.wastes.map((rate) => {
        const base = parseFloat(rate.price) || 0;
        let newPrice;

        if (adjustmentType === "percent") {
          newPrice = base + (base * adjustmentValue) / 100;
        } else {
          newPrice = base + adjustmentValue;
        }

        return { ...rate, price: parseFloat(newPrice.toFixed(2)) };
      }),
    }));

    replace(updatedPlans);
  };

  return (
    <Card className="mb-3 p-3">
      <h5>Masowa zmiana cen</h5>
      <div className="d-flex align-items-center gap-3">
        <select
          className="form-select"
          style={{ width: "180px" }}
          value={adjustmentType}
          onChange={(e) => setAdjustmentType(e.target.value)}
        >
          <option value="percent">Zwiększ o %</option>
          <option value="fixed">Zwiększ o kwotę</option>
        </select>

        <input
          type="number"
          className="form-control"
          style={{ width: "120px" }}
          value={adjustmentValue}
          onChange={(e) => setAdjustmentValue(parseFloat(e.target.value))}
          placeholder="np. 10"
        />

        <DomainButton onClick={applyAdjustment}>Zastosuj</DomainButton>
      </div>
    </Card>
  );
};

const getRatePlanItems = (data) => {
  const isCloneMode = data.updateMode === "clone";

  return data.ratePlans.map(plan => {
    const grouped = plan.wastes.reduce((acc, w) => {
      const key = w.wasteKind?.wasteKindId ?? w.wasteId;
      if (!acc[key]) {
        acc[key] = {
          id: w.id,
          entityId: w.wasteId,
          pricingType: "Waste",
          price: undefined,
          wasteKindId: w.wasteKind?.wasteKindId,
          isAdvancedPricing: false,
          wasteAdvancedPricing: null
        };
      }

      // if this waste entry uses advanced pricing, collect its advanced price entries
      if (w.isAdvancedPricing) {
        acc[key].isAdvancedPricing = true;
        acc[key].wasteAdvancedPricing ??= [];
        acc[key].wasteAdvancedPricing.push({
          wasteFormType: w.wasteFormType,
          price: w.price
        });

        // const adv = w.wasteAdvancedPricing;
        // Object.keys(adv).forEach(formKey => {
        //   acc[key].wasteAdvancedPricing.push({
        //     wasteFormType: WASTE_FORM_TYPE[formKey] ?? formKey,
        //     price: adv[formKey]
        //   });
        // });
      } else {
        // use first non-advanced price encountered (keeps existing if already set)
        if (acc[key].price === undefined) {
          acc[key].price = w.price;
        }
      }

      return acc;
    }, {});

    return {
      id: plan.ratePlanId,
      items: Object.values(grouped),
      dateToForOriginalRatePlan: isCloneMode && plan.dateToForOriginalRatePlan !== "" ? plan.dateToForOriginalRatePlan : null,
      dateFromForNewRatePlan: isCloneMode && plan.dateFromForNewRatePlan !== "" ? plan.dateFromForNewRatePlan : null,
      dateToForNewRatePlan: isCloneMode && plan.dateToForNewRatePlan !== "" ? plan.dateToForNewRatePlan : null
    };
  });
}